import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

import { pageTransitions } from '../../../shared/animations/page-transitions';
import { DialogNewOfferRequestComponent } from '../utils/dialog-new-offer-request/dialog-new-offer-request.component';
import { OrderBy, OrderByDirection } from '../../../shared/utils/constant';
import { OfferDraft } from '../../models/offer';
import { AppOfferService } from '../../services/app-offer.service';
import { AppWizardService } from '../../services/app-wizard.service';
import { OfferService } from '../../services/offer.api.service';
import { UserService } from '../../../shared/services/user.service';
import { NumberPipe } from '../../../shared/pipes/number.pipe';
import { LoadingSpinnerComponent } from '../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-request-offer-widget',
	templateUrl: './offer-request-widget.component.html',
	styleUrl: './offer-request-widget.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		TranslateModule,

		MatButtonModule,
		MatIconModule,
		RouterLink,
		LoadingSpinnerComponent,
		NumberPipe
	]
})
export class OfferRequestWidgetComponent implements OnInit {
	@Input() headerLabel!: string;
	@Input() btnLabel!: string;
	@Input() btnRouterLink!: string;
	draftCount = 0;
	offerDraftSubscription?: Subscription;
	isLoading = true;
	requiredFields: (keyof OfferDraft)[] = ['id'];
	filters = '';
	sortWay = OrderByDirection.DESC;
	sortBy: keyof OfferDraft = 'modificationDate';

	constructor(
		private readonly offerService: OfferService,
		private readonly appOfferService: AppOfferService,
		private readonly appWizardService: AppWizardService,

		private readonly dialog: MatDialog,
		private readonly userService: UserService

	) {}

	ngOnInit() {
		this.offerDraftSubscription = this.offerService.getDraftOffers(
			this.requiredFields,
			this.filters,
			0,
			60_000,
			new OrderBy(this.sortBy, this.sortWay),
			false
		).subscribe({
			next: response => {
				this.draftCount = response.count;
				this.isLoading = false;
			},
			error: (err: unknown) => {
				console.error('unable to retrieve draft offer count', err);
				this.isLoading = false;
				this.appOfferService.showError();
			}
		});
	}

	async handleNewOfferWidget() {
		await this.appWizardService.actionNewOffer();
	}

	async evtRequestNewOffer() {
		if (this.userService.user.hasServiceParameterEqualsTo('EOFFR', 'offerFrameworkOpen', 'True')) {
			this.dialog.open<DialogNewOfferRequestComponent, undefined, number>(DialogNewOfferRequestComponent, {
				panelClass: 'copo-offer-dialog', disableClose: true
			});
		} else {
			sessionStorage.setItem('offertype', 'spot');
			await this.appWizardService.actionNewOffer();
		}
	}
}
